import React, { useState, useRef } from "react";
import moment from "moment";
import { Button, ButtonGroup } from "react-bootstrap";
import { ClockHistory, Envelope, Archive, Download } from "react-bootstrap-icons"

import { AgGridReact } from 'ag-grid-react'; // React Data Grid Component
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community'; 

import { renderStatus } from "../../_helpers/components";
import { getBackupItem } from "../../_helpers/api";

import MailViewer from "../MailViewer";
import HistoryViewer from "../HistoryViewer";
import ArchiveModal from "../ArchiveModal";

// Register all Community features
ModuleRegistry.registerModules([AllCommunityModule]);

const ItemsGrid = (props) => {

  const gridRef = useRef();

  const [ showMailViewer, setShowMailViewer ] = useState(false);
  const [ selectedMail, setSelectedMail ] = useState("");

  const [ showHistoryViewer, setShowHistoryViewer ] = useState(false);
  const [ selectedHistory, setSelectedHistory ] = useState([]);

  const [ showArchiveModal, setShowArchiveModal ] = useState(false);
  const [ selectedItem, setSelectedItem ] = useState(null);

  const handleArchiveClick = (item) => {
    setSelectedItem(item);
    setShowArchiveModal(true);
  };

  const handleExportCsv = () => {
    gridRef.current.api.exportDataAsCsv({
      fileName: `backup-items-${moment().format('YYYY-MM-DD')}.csv`
    });
  };

  const historyClickHandler = (itemId) => {
    getBackupItem(itemId).then((item) => {
      setSelectedHistory(item.history || []);
      setShowHistoryViewer(true);
    }).catch((error) => {
      console.error("Error fetching backup item for history:", error);
    });
  };

  const renderButtons = (params) => {
    const mailId = params.data.mailId;
    return (
      <ButtonGroup>
        <Button variant="link" size="sm" onClick={() => { setSelectedMail(mailId); setShowMailViewer(true)}}><Envelope /></Button>
        <Button variant="link" size="sm" onClick={() => historyClickHandler(params.data._id)}><ClockHistory /></Button>
        {!props.showArchived && (
          <Button variant="link" size="sm" onClick={() => handleArchiveClick(params.data)}><Archive /></Button>
        )}
      </ButtonGroup>
    );
  }

  // Column Definitions: Defines the columns to be displayed.
  const enableFilter = props.filterLastSuccess === 0;
  const colDefs = [
      { field: "kunde", sortable: true, filter: enableFilter, flex: 2, sort: 'asc'},
      { field: "name", sortable: true, filter: enableFilter, flex: 2},
      { field: "jobName" , sortable: true, filter: enableFilter, flex: 2},
      { field: "software", sortable: true, filter: enableFilter, flex: 2},
      { field: "typ", sortable: true, filter: enableFilter, flex: 1},

      { field: "status", sortable: true, filter: enableFilter, flex: 1,
        cellRenderer: (params) => renderStatus(params.value
      )},
      { field: "mailReceivedTime", sortable: true, flex: 2, //filter: 'agDateColumnFilter',
        valueFormatter: (params) => moment(params.value).format("DD.MM.YYYY HH:mm:ss")
      },
      
      { field: "", sortable: false, filter: false, flex: 1.5, cellRenderer: renderButtons}
  ];

  const colDefsArchived = [
    { field: "kunde", sortable: true, filter: enableFilter, flex: 2},
    { field: "name", sortable: true, filter: enableFilter, flex: 2},
    { field: "jobName" , sortable: true, filter: enableFilter, flex: 2},
    { field: "software", sortable: true, filter: enableFilter, flex: 2},
    { field: "typ", sortable: true, filter: enableFilter, flex: 1},
    { field: "lifecycle.status", sortable: true, filter: enableFilter, flex: 2},
    { field: "lifecycle.updatedAt", sortable: true, filter: enableFilter, sort: 'desc', flex: 2,
      valueFormatter: (params) => params.value ? moment(params.value).format("DD.MM.YYYY HH:mm:ss") : ""
    },
    { field: "lifecycle.updatedBy", sortable: true, filter: enableFilter, flex: 2},
    { field: "lifecycle.lifecycleReason", sortable: true, filter: enableFilter, flex: 3},
    { field: "", sortable: false, filter: false, flex: 1.5, cellRenderer: renderButtons}
  ];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1, overflow: 'hidden' }}>
        <div className="mb-2 text-end">
          <Button variant="link" size="sm" onClick={handleExportCsv}>
            <Download className="me-1" />
            Export as CSV
          </Button>
        </div>
        <div
            style={{ flex: 1, minHeight: 0, width: "100%" }}
        >
            <AgGridReact
                    ref={gridRef}
                    rowData={props.backupItems}
                    columnDefs={props.showArchived ? colDefsArchived : colDefs}
            />
        </div>
        <MailViewer show={showMailViewer} handleClose={() => setShowMailViewer(!showMailViewer)} mailId={selectedMail}/>
        <HistoryViewer show={showHistoryViewer} handleClose={() => setShowHistoryViewer(!showHistoryViewer)} history={selectedHistory}/>
        <ArchiveModal show={showArchiveModal} handleClose={() => setShowArchiveModal(false)} item={selectedItem}/>
    </div>
  );
}

export default ItemsGrid;